<p>
  Data estimada: {{parameter.data_estimada | date: 'dd/MM'}}
</p>
<div ng-if="parameter.status === 'applied'">
  <p ng-class="{ 'text-emergencia': $ctrl.wasAppliedLate(parameter) }">
    Data efetiva: {{parameter.data_fim_aplicacao | date: 'dd/MM'}}
    <i
      class="fa fa-exclamation-triangle"
      ng-if="$ctrl.wasAppliedLate(parameter)"
      uib-tooltip="Aplicada após a data estimada"
      tooltip-append-to-body="true"
      tooltip-placement="right"
    ></i>
  </p>
  <p>
    Dias após aplicado: {{parameter.dias_apos_aplicado}}
  </p>
</div>
<div ng-if="parameter.observacoes">
  <p><b>Observações</b></p>
  <p>{{parameter.observacoes}}</p>
</div>
<table class="table table-striped" ng-if="parameter.items.length > 0">
  <thead>
    <tr>
      <th>Produto</th>
      <th>Dose</th>
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="produto in parameter.items track by produto.id">
      <td>{{produto.item_estoque.descricao}}</td>
      <td>{{produto.dose | number:3}} {{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}/ha</td>
      <td>{{produto.dose * (+parameter.area || schedule.gleba.area_total) | number:2}} {{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}</td>
    </tr>
  </tbody>
</table>

<div class="text-right">
  <a ng-click="$ctrl.goToRecommendation(schedule, parameter, $event)" ng-if="parameter.status !== 'applied' || parameter.recomendacao">{{$ctrl.hasValidRecommendation(parameter) ? 'Ver' : 'Criar'}} recomendação</a>
</div>
<div class="text-right">
  <a ng-click="$ctrl.openAplicacoes(parameter, schedule)" ng-if="parameter.status !== 'applied'">Vincular aplicação</a>
</div>
<div class="text-right" ng-if="parameter.status === 'applied' || parameter.status === 'in_progress'">
  <a
    ng-click="$ctrl.openDetails(parameter)"
  >Ver aplicações</a>
</div>
<div class="text-right finaliza-cronograma-fungicida-parameter" ng-if="parameter.status === 'in_progress'">
  <a ng-click="$ctrl.finalizaCronogramaFungicidaParameter(parameter.id)">Toda essa área já foi aplicada?</a>
</div>
